var huddle = {};

huddle.start = function(url, room, name, email) {
  var info = `#userInfo.displayName=${name}&userInfo.email=${email}`;
  if (device.platform.toLowerCase() == "browser") {
    window.open(url + room + info, "_system");
  } else {
    if (device.platform.toLowerCase() == "android") {
      jitsiplugin.loadURL(
        url + room,
        room,
        false,
        function(data) {
          if (data === "CONFERENCE_WILL_LEAVE") {
            jitsiplugin.destroy(
              function(data) {
                // call finished
              },
              function(err) {
                console.log(err);
              }
            );
          }
        },
        function(err) {
          console.log(err);
        }
      );
    } else {
      jitsiplugin.join(
        url,
        room,
        false,
        function(data) {
          if (data === "CONFERENCE_TERMINATED") {
            jitsiplugin.destroy(
              function(data) {
                // call finished
              },
              function(err) {
                console.log(err);
              }
            );
          }
        },
        function(err) {
          console.log(err);
        }
      );
    }
  }
};

export default huddle;
